



















import gql from 'graphql-tag';
import { filter, flow, keyBy, map, omit, upperFirst } from 'lodash';

import ZenObjectsDropdown from '@/components/zen_objects_dropdown/ZenObjectsDropdown.vue';

import { filterPresenterMixin } from './common';

const OBJECT_TYPE_ATTRIBUTES_QUERY = gql`
  query ObjectTypeAttributes($type: SearchType!, $context: AttributesContext!) {
    objectType(name: $type) {
      attrs(context: $context) {
        name
        attrName
        filterable
        isMapping
      }
    }
  }
`;

export default {
  name: 'MappedObjectsFilterAttributePresenter',
  components: {
    ZenObjectsDropdown,
  },
  props: {
    ...filterPresenterMixin.props,
  },
  data() {
    return {
      objects: [],
      internalValue: null,
    };
  },
  computed: {
    // TODO: TEMP, make this generic (maybe use filters meta to
    //   specify it's a filter which doesn't need a value selected)
    filterWithoutValue(): boolean {
      return this.operator !== '=';
    },

    attributesMeta() {
      return keyBy(this.objectTypeAttributes, 'name');
    },
    // TODO: TEMP, fix GQL to return canonical form (UpperCamelCase) of object type for mapping attrs,
    //   either for the `name` field or have it's own field (i.e. `mappedObjectType` field)
    mappedObjectType() {
      const attrName = this.attributesMeta[this.attribute].attrName;

      let canonicalAttrName = upperFirst(attrName);

      // Handles plural names
      if (canonicalAttrName === 'Dataasset') canonicalAttrName = 'DataAsset';
      if (canonicalAttrName === 'Externalrequest') canonicalAttrName = 'ExternalRequest';
      if (canonicalAttrName === 'Surveyresponse') canonicalAttrName = 'SurveyResponse';
      if (canonicalAttrName === 'Orggroup') canonicalAttrName = 'OrgGroup';

      // Handles attributes for relevant object types
      if (canonicalAttrName === 'Relevant_assessments') canonicalAttrName = 'Assessment';
      if (canonicalAttrName === 'Relevant_audits') canonicalAttrName = 'Audit';
      if (canonicalAttrName === 'Relevant_controls') canonicalAttrName = 'Control';
      if (canonicalAttrName === 'Relevant_programs') canonicalAttrName = 'Program';

      return canonicalAttrName;
    },
  },
  watch: {
    value(newValue) {
      // TODO: TEMP
      //   it should select the { value, label } object for the passed in value
      if (newValue) return;

      this.internalValue = null;
    },
  },
  // TODO: TEMP handle this cleaner
  mounted() {
    // We only case it it's a filter which doesn't need a value selected
    if (this.filterWithoutValue) {
      this.$emit('input', '');
    }
  },
  methods: {
    onObjectChange(object): void {
      this.$emit('input', object.value);
    },
  },
  apollo: {
    objectTypeAttributes: {
      query: OBJECT_TYPE_ATTRIBUTES_QUERY,
      variables() {
        return {
          type: this.objectType,
          context: 'SOR_LISTING',
        };
      },
      update(data) {
        const attrs = data.objectType.attrs;

        // TODO: make a generic util (pass attrs to filter by and omit them from result)
        //
        // TODO: should be added back after GQL returns canonical form of object type for mapping attrs
        // const mappings = attrs => filter(attrs, attr => attr.isMapping);
        const filterable = attrs => filter(attrs, attr => attr.filterable);
        const omitMeta = attrs => map(attrs, attr => omit(attr, ['isMapping', 'filterable']));
        const filterAndOmit = flow(filterable, omitMeta);

        return filterAndOmit(attrs);
      },
    },
  },
};
